export const gitVersion = '1.0.0-7-ge6d463c';
